import React, { createContext, useContext, useMemo } from 'react';

const TransactionPanelContext = createContext(null);

export const TransactionPanelProvider = ({
    children,
    messages = [],
    appointmentEntities = {},
    organizedItems = [],
    formError,
}) => {
    const value = useMemo(() => ({ messages, appointmentEntities, organizedItems, formError }), [
        messages,
        appointmentEntities,
        organizedItems,
        formError,
    ]);

    return (
        <TransactionPanelContext.Provider value={value}>
            {children}
        </TransactionPanelContext.Provider>
    );
};

export const useTransactionPanelContext = () => {
    const context = useContext(TransactionPanelContext);

    if (!context) {
        throw new Error('useTransactionPanelContext must be used within TransactionPanelProvider.');
    }

    return context;
};
